import { getCurrentInstance, onBeforeUnmount, ref } from 'vue'
import { backendStall, type StallDetector } from '@/services/backendStall'

/** Whether the backend is stalled right now (services/backendStall.ts), as a ref. */
export function useBackendStalled(detector: StallDetector = backendStall) {
  const stalled = ref(detector.isStalled())
  const stop = detector.subscribe((value) => { stalled.value = value })
  if (getCurrentInstance()) onBeforeUnmount(stop)
  return stalled
}
